import React from 'react';

const About = () => {
  const freshaBookingUrl =
    "https://www.fresha.com/a/zoteya-beauty-salon-sandton-33-wessel-road-bw27doko?pId=2602836";

  return (
    <section id="about" className="pt-4 pb-3" style={{ background: "#ffffff" }}>
      <div className="container py-1">
        <div className="row align-items-center gy-3">
          <div className="col-12">
            <h1
              className="fw-bold mb-2"
              style={{
                fontFamily: "'Playfair Display',serif",
                color: "#433e3a",
                fontSize: "1.22rem",
                letterSpacing: ".035em",
                marginBottom: "0.7em"
              }}
            >
              About Zoteya Beauty
            </h1>
            <p
              className="text-secondary mb-2"
              style={{ lineHeight: "1.35", fontSize: ".99rem" }}
            >
              Zoteya Beauty is a luxury Sandton salon specialising in high‑quality installs and
              extensions for women of colour, with a focus on effortless, polished hair.
            </p>
            <p
              className="fw-semibold mb-3"
              style={{
                fontSize: ".97rem",
                letterSpacing: ".01em",
                color: "#2c2c2c"
              }}
            >
              Proudly 100% Black‑owned.
            </p>
            <a
              href={freshaBookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn px-4 py-2 fw-bold shadow rounded-pill mt-2"
              style={{
                background: "#d4c4a8",
                color: "#3a3a3a",
                fontSize: ".98rem",
                letterSpacing: ".07em",
                border: "none",
                textTransform: "uppercase",
                boxShadow: "0 2px 14px #baa56030",
                transition: "background 0.3s"
              }}
              onMouseOver={e => (e.currentTarget.style.background = "#cab27c")}
              onMouseOut={e => (e.currentTarget.style.background = "#d4c4a8")}
            >
              Book Appointment
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
